import Layout from "@/Layout";
export const asyncRouterMap = [
  {
    path: "/",
    component: Layout,
    redirect: "/users/list"
  },
  {
    path: "/users",
    component: Layout,
    redirect: "/users/list",
    children: [
      {
        path: "list",
        component: () => import("@/views/users/index"),
        name: "usersList",
        meta: {
          title: "users",
          icon: "mdi-account-multiple"
        }
      }
    ]
  },
  {
    path: "/roles",
    component: Layout,
    redirect: "/roles/list",
    meta: {
      title: "roles",
      icon: "mdi-arrange-send-to-back"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/roles"),
        name: "roles",
        meta: {
          title: "list",
          icon: "mdi-menu"
        }
      },
      {
        path: "new",
        component: () => import("@/views/roles/new"),
        name: "new",
        // hidden: true,
        meta: {
          title: "create",
          icon: "mdi-plus"
        }
      }
    ]
  },
  {
    path: "/contactMessage",
    component: Layout,
    redirect: "/contactMessage/list",
    meta: {
      title: "contacts",
      icon: "mdi-contacts"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/contactMessage"),
        name: "contact",
        meta: {
          title: "list",
          icon: "mdi-menu"
        }
      },
      {
        path: "topics",
        component: () => import("@/views/contactMessage/topics"),
        name: "topics",
        meta: {
          title: "topics",
          icon: "mdi-gate"
        }
      }
    ]
  },
  {
    path: "/programs",
    component: Layout,
    redirect: "/programs/list",
    meta: {
      title: "programs",
      icon: "mdi-group"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/programs"),
        name: "programs",
        meta: {
          title: "list",
          icon: "mdi-menu"
        }
      },
      {
        path: "create",
        component: () => import("@/views/programs/form"),
        name: "create_program",
        hidden: true,
        meta: {
          title: "create_program",
          icon: "mdi-plus"
        }
      },
      {
        path: "edit/:slug",
        component: () => import("@/views/programs/form"),
        name: "edit_program",
        hidden: true,
        meta: {
          title: "edit_program",
          icon: "mdi-buffer"
        }
      },
      {
        path: "programs/status",
        component: () => import("@/views/programs/status"),
        name: "program-statuses",
        meta: {
          title: "order_status",
          icon: "mdi-plus"
        }
      },
      {
        path: "orders",
        component: () => import("@/views/programs/orders"),
        name: "program-order",
        meta: {
          title: "program_orders",
          icon: "mdi-label"
        }
      }
    ]
  },
  {
    path: "/products",
    component: Layout,
    redirect: "/products/list",
    meta: {
      title: "products",
      icon: "mdi-fan"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/products"),
        name: "products",
        meta: {
          title: "list",
          icon: "mdi-menu"
        }
      },
      {
        path: "create",
        component: () => import("@/views/products/formAction"),
        name: "create_product",
        hidden: true,
        meta: {
          title: "create_product",
          icon: "mdi-account-circle"
        }
      },
      {
        path: "edit/:slug",
        component: () => import("@/views/products/formAction"),
        name: "edit_product",
        hidden: true,
        meta: {
          title: "edit_product",
          icon: "mdi-account-circle"
        }
      },
      {
        path: "status",
        component: () => import("@/views/products/status"),
        name: "product-statuses",
        meta: {
          title: "order_status",
          icon: "mdi-plus"
        }
      },
      {
        path: "orders",
        component: () => import("@/views/products/orders"),
        name: "product-order",
        meta: {
          title: "product_orders",
          icon: "mdi-label"
        }
      }
    ]
  },
  {
    path: "/members",
    component: Layout,
    redirect: "/members/list",
    meta: {
      title: "Members",
      icon: "mdi-account-network"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/members/index"),
        name: "MembersList",
        meta: {
          title: "council_members",
          icon: "mdi-account-network"
        }
      }
    ]
  },
  {
    path: "/new-members",
    component: Layout,
    redirect: "/new-members/list",
    meta: {
      title: "new Members",
      icon: "mdi-account-network"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/newMembers/index"),
        name: "MembersList",
        meta: {
          title: "newMembers",
          icon: "mdi-account-network"
        }
      },
      {
        path: "create-member",
        component: () => import("@/views/newMembers/crud"),
        name: "create-new-member",
        hidden: true,
        meta: {
          title: "newMembers",
          icon: "mdi-account-network"
        }
      },
      {
        path: "edit/:slug",
        component: () => import("@/views/newMembers/crud"),
        name: "edit-new-member",
        hidden: true,
        meta: {
          title: "newMembersEdit",
          icon: "mdi-account-network"
        }
      }
    ]
  },
  {
    path: "/beneficiaries",
    component: Layout,
    redirect: "/beneficiaries/list",
    meta: {
      title: "beneficiaries",
      icon: "mdi-account-network"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/beneficiaries/index"),
        name: "beneficiaries",
        meta: {
          title: "beneficiaries",
          icon: "mdi-account-network"
        }
      },
      {
        path: "create-beneficiaries",
        component: () => import("@/views/beneficiaries/crud"),
        name: "create-beneficiaries",
        hidden: true,
        meta: {
          title: "beneficiaries",
          icon: "mdi-account-network"
        }
      },
      {
        path: "edit/:id",
        component: () => import("@/views/beneficiaries/crud"),
        name: "edit-beneficiaries",
        hidden: true,
        meta: {
          title: "beneficiariesEdit",
          icon: "mdi-account-network"
        }
      }
    ]
  },
  {
    path: "/question",
    component: Layout,
    redirect: "/question/list",
    alwaysShow: true,
    meta: {
      title: "Questions",
      icon: "mdi-account-network"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/questions/index"),
        name: "questionList",
        meta: {
          title: "questions",
          icon: "mdi-account-network"
        }
      },
      {
        path: "questions-groups",
        component: () => import("@/views/questions/questions-groups"),
        name: "questions_groups",
        meta: {
          title: "Questions Groups",
          icon: "mdi-account-network"
        }
      },
      {
        path: "survey",
        component: () => import("@/views/questions/survey"),
        name: "survey",
        meta: {
          title: "survey",
          icon: "mdi-account-network"
        }
      }
    ]
  },
  {
    path: "/meetings",
    component: Layout,
    redirect: "/meetings/list",
    meta: {
      title: "Meetings",
      icon: "mdi-account-network"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/meetings/index.vue"),
        name: "MeetingsList",
        meta: {
          title: "Meetings",
          icon: "mdi-account-network"
        }
      }
    ]
  },
  {
    path: "/news",
    component: Layout,
    redirect: "/news",
    name: "News",
    meta: {
      permission: "index_news"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/news/index"),
        name: "AllNews",
        meta: { title: "news", icon: "mdi-newspaper" }
      },
      {
        path: "new",
        component: () => import("@/views/news/new"),
        name: "createNews",
        hidden: true,
        meta: {
          title: "create_news"
        }
      }
    ]
  },
  {
    path: "/services",
    component: Layout,
    redirect: "/services/list",
    meta: {
      title: "Services",
      icon: "mdi-account-circle"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/services/index"),
        name: "services",
        meta: {
          title: "services",
          icon: "mdi-server-plus"
        }
      },
      {
        path: "create",
        component: () => import("@/views/services/formAction"),
        name: "create_service",
        hidden: true,
        meta: {
          title: "create_service"
        }
      },
      {
        path: "edit/:slug",
        component: () => import("@/views/services/formAction"),
        name: "edit_service",
        hidden: true,
        meta: {
          title: "edit_service"
        }
      }
    ]
  },
  {
    path: "/labels",
    component: Layout,
    redirect: "/labels/list",
    meta: {
      title: "labels",
      icon: "mdi-account-circle"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/labels/index"),
        name: "labelsList",
        meta: {
          title: "labels",
          icon: "mdi-label"
        }
      },
      {
        path: "add",
        component: () => import("@/views/labels/addLabel"),
        name: "addLabel",
        hidden: true,
        meta: {
          title: "create_label"
        }
      },
      {
        path: "edit/:id",
        component: () => import("@/views/labels/editLabel"),
        name: "editLabel",
        hidden: true,
        meta: {
          title: "edit_label"
        }
      }
    ]
  },
  {
    path: "/branches",
    component: Layout,
    redirect: "/branches/list",
    meta: {
      title: "branches",
      icon: "mdi-account-circle"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/branches/index"),
        name: "branches",
        meta: {
          title: "branches",
          icon: "mdi-server-plus"
        }
      },
      {
        path: "create",
        component: () => import("@/views/branches/formAction"),
        name: "create",
        hidden: true,
        meta: {
          title: "create_branch"
        }
      },
      {
        path: "edit/:slug",
        component: () => import("@/views/branches/formAction"),
        name: "edit",
        hidden: true,
        meta: {
          title: "edit_branch"
        }
      }
    ]
  },
  {
    path: "/survey-forms",
    component: Layout,
    redirect: "/surveyForms/list",
    name: "surveyForms",
    meta: {
      title: "surveyForms",
      icon: "mdi-form-select"
    },
    // meta: { permission: "index_tag", icon: "mdi-form-select" },
    children: [
      {
        path: "list",
        component: () => import("@/views/surveyForms/index"),
        name: "surveyFormsList",
        meta: { title: "survey-forms", icon: "mdi-form-select" }
      },
      {
        path: ":id/answers",
        component: () => import("@/views/surveyForms/answers"),
        name: "answers",
        hidden: true,
        meta: {
          title: "answers"
        }
      }
    ]
  },
  {
    path: "/tags",
    component: Layout,
    redirect: "/tags/list",
    name: "Tags",
    meta: { permission: "index_tag", icon: "mdi-cloud-tags" },
    children: [
      {
        path: "list",
        component: () => import("@/views/tags/index"),
        name: "TagsList",
        meta: { title: "tags", icon: "mdi-cloud-tags" }
      }
    ]
  },
  {
    path: "/supporters",
    component: Layout,
    redirect: "/supporters/list",
    meta: {
      title: "labels",
      icon: "mdi-account-circle"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/supporters"),
        name: "supportersList",
        meta: {
          title: "supporters",
          icon: "mdi-account-settings"
        }
      },
      {
        path: "add",
        component: () => import("@/views/supporters/addSupporter"),
        name: "addSupporter",
        hidden: true,
        meta: {
          title: "add_supporter"
        }
      },
      {
        path: "edit/:slug",
        component: () => import("@/views/supporters/editSupporter"),
        name: "editSupporter",
        hidden: true,
        meta: {
          title: "edit_supporter"
        }
      }
    ]
  },
  {
    path: "/countries",
    component: Layout,
    redirect: "/countries/list",
    meta: {
      title: "countries",
      icon: "mdi-account-circle"
    },

    children: [
      {
        path: "list",
        component: () => import("@/views/countries"),
        name: "countries",
        meta: {
          title: "countries",
          icon: "mdi-earth-box"
        }
      },
      {
        path: ":id/states",
        component: () => import("@/views/countries/states"),
        name: "states",
        meta: {
          title: "list",
          icon: "mdi-account-circle"
        },
        hidden: true
      },
      {
        path: ":id/cities",
        component: () => import("@/views/countries/cities"),
        name: "cities",
        meta: {
          title: "list",
          icon: "mdi-account-circle"
        },
        hidden: true
      }
    ]
  },
  // {
  //   path: "/galleries",
  //   component: Layout,
  //   redirect: "/galleries/list",
  //   meta: {
  //     title: "galleries",
  //     icon: "mdi-account-circle",
  //   },

  //   children: [
  //     {
  //       path: "list",
  //       component: () => import("@/views/galleries"),
  //       name: "galleries",
  //       meta: {
  //         title: "galleries",
  //         icon: "mdi-folder-image",
  //       },
  //     },
  //     {
  //       path: "create",
  //       component: () => import("@/views/galleries/create"),
  //       name: "create_galleries",
  //       meta: {
  //         title: "create",
  //         icon: "mdi-account-circle",
  //       },
  //       hidden: true,
  //     },
  //   ],
  // },
  {
    path: "/subscriptions",
    component: Layout,
    redirect: "/subscriptions/list",
    meta: {
      title: "subscriptions",
      icon: "mdi-account-circle"
    },

    children: [
      {
        path: "list",
        component: () => import("@/views/subscriptions"),
        name: "subscriptions",
        meta: {
          title: "subscriptions",
          icon: "mdi-nfc-variant"
        }
      }
    ]
  },
  {
    path: "/pages",
    component: Layout,
    redirect: "/pages/media-center",
    alwaysShow: true,
    meta: {
      title: "pages",
      icon: "mdi-receipt"
    },
    children: [
      {
        path: "media-center",
        component: () => import("@/views/pages/index"),
        name: "media_center",
        meta: {
          title: "media Center",
          icon: "mdi-earth"
        }
      },
      {
        path: "identity",
        component: () => import("@/views/pages/index"),
        name: "identity",
        meta: {
          title: "identity",
          icon: "mdi-earth"
        }
      },
      {
        path: "informations",
        component: () => import("@/views/pages/index"),
        name: "informations",
        meta: {
          title: "informations",
          icon: "mdi-earth"
        }
      }
    ]
  },
  {
    path: "/files-reporters",
    component: Layout,
    redirect: "/files-reporters/list",
    meta: {
      title: "files and reporters",
      icon: "mdi-account-network"
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/filesAndReports/index"),
        name: "FilesList",
        meta: {
          title: "files And Reports",
          icon: "mdi-account-network"
        }
      }
    ]
  },
  {
    path: "/settings",
    component: Layout,
    redirect: "/settings/global",
    alwaysShow: true,
    meta: {
      title: "settings",
      icon: "mdi-receipt"
    },
    children: [
      {
        path: "global",
        component: () => import("@/views/settings"),
        name: "global",
        meta: {
          title: "global",
          icon: "mdi-earth"
        }
      },
      {
        path: "terms-policy",
        component: () => import("@/views/settings"),
        name: "terms_policy",
        meta: {
          title: "terms_policy",
          icon: "mdi-cards-variant"
        }
      },
      // {
      //   path: "features",
      //   component: () => import("@/views/settings"),
      //   name: "features",
      //   meta: {
      //     title: "features",
      //     icon: "mdi-account-circle"
      //   }
      // },
      {
        path: "contact-page",
        component: () => import("@/views/settings"),
        name: "contact_page",
        meta: {
          title: "contacts",
          icon: "mdi-cellphone-settings"
        }
      }
    ]
  },

  { path: "*", redirect: "/404", hidden: true }
];
